export class CToggle extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    const isDisabled = this.hasAttribute('disabled');
    const isToggled = this.hasAttribute('toggled');
    const label = this.getAttribute('label') || '';
    const description = this.getAttribute('description') || '';

    this.shadowRoot.innerHTML = `
        <style>
            :host {
                display: flex;
                gap: 5px;
                align-items: start;
            }
            .toggle {
                position: relative;
                width: 48px;
                height: 24px;
                background: var(--light-blue-200);
                border-radius: 50px;
                cursor: pointer;
                transition: background 0.3s ease;
                opacity: ${isDisabled ? '.8' : '1'};
            }
            .toggle:hover{
                background-color: ${!isDisabled ? 'var(--light-blue-300)' : 'var(--light-blue-200)'};
            }
            .circle {
                position: absolute;
                top: 4px;
                left: 4px;
                width: 16px;
                height: 16px;
                background: var(--white);
                border-radius: 50%;
                transition: transform 0.3s ease;
                }
            .off-circle{
                position: absolute;
                top: 6px;
                right: 6px;
                width: 10px;
                border-radius: 10px;
                height: 10px;
                border: 1px var(--white) solid;
            }
            input {
                display: none;
            }
            input:checked + .toggle {
                background: var(--tempora-primary);
            }
            input:checked + .toggle:hover{
                background-color: ${!isDisabled ? 'var(--tempora-primary-hover)' : 'var(--tempora-primary)'}
            }
            input:checked + .toggle .circle {
                transform: translateX(24px);
            }
            .label_description{
                display: flex;
                flex-direction: column;
                padding-top: 4px;
                color: var(--black)
            }
            .description{
                color: var(--black-64);
                font-size: 14px
            }
        </style>

        <label>
            <input 
                type="checkbox" 
                ${isToggled ? 'checked' : ''}
                ${isDisabled ? 'disabled' : ''}
            />
            <div class="toggle">
            <div class="circle"></div>
            <span class="off-circle"></span>
            </div>
        </label>
        <div class="label_description">
            <span class="label">${label ? label : ''}</span>
            <span class="description">${label && description ? description : ''}</span>
        </div>
    `;

    this.input = this.shadowRoot.querySelector('input');
  }

  get checked() {
    return this.input.checked;
  }

  set checked(val) {
    this.input.checked = val;
  }
}

customElements.define('c-toggle', CToggle);